import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { TemplatePage } from "../../../0_TemplatePage/TemplatePage";
import { useNavigate } from "react-router-dom";
import KsbActionButton from "../../../components/KsbActionButton";

export default function VerificationTemplate({
  state, // "info" | "loading" | "success" | "error"
  msg,
}) {
  const theme = useTheme();

  const navigate = useNavigate();

  let icon, title, content;

  switch (state) {
    case "info":
      title = "E-Mail überprüfen";
      content = (
        <>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.text.inactive }}
          >
            Bitte überprüfe dein E-Mail-Postfach.
          </Typography>
          <Typography
            variant="body2"
            sx={{ mt: 3, color: theme.palette.text.inactive }}
          >
            Klicke auf den Bestätigungslink.
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.text.inactive }}
          >
            Leider kann es 2-3 Minuten dauern...
          </Typography>
        </>
      );
      break;

    case "loading":
      content = (
        <Box sx={{ py: 4 }}>
          <CircularProgress
            sx={{ color: theme.palette.primary.main }}
            size="3rem"
          />
          <Typography sx={{ mt: 2, color: theme.palette.text.inactive }}>
            Verifikation läuft...
          </Typography>
        </Box>
      );
      break;

    case "success":
      icon = (
        <CheckCircleOutlineIcon
          sx={{ fontSize: 48, color: theme.palette.levels.green }}
        />
      );
      title = "Verifikation erfolgreich";
      content = (
        <Typography sx={{ color: theme.palette.text.inactive }}>
          Dein Konto wurde aktiviert.
        </Typography>
      );
      break;

    case "error":
      icon = (
        <ErrorOutlineIcon
          sx={{ fontSize: 48, color: theme.palette.error.main }}
        />
      );
      title = "Ungültiger Link";
      content = (
        <Typography sx={{ color: theme.palette.text.inactive }}>
          Der Link ist ungültig oder abgelaufen.
        </Typography>
      );
      break;

    default:
      break;
  }

  return (
    <TemplatePage type="default">
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: "100%",
            maxWidth: 420,
            borderRadius: 3,
            p: 4,
            textAlign: "center",
          }}
        >
          {icon}

          {title && (
            <Typography variant="h5" sx={{ mt: 1, mb: 1 }}>
              {title}
            </Typography>
          )}

          {content}

          {msg && (
            <Typography sx={{ mt: 2, color: theme.palette.text.secondary }}>
              {msg}
            </Typography>
          )}

          {/* ✅ SINGLE CTA (always consistent) */}
          <KsbActionButton
            onClick={() => navigate("/login")}
            icon={<ArrowBackIcon />}
            desktopIcon={<ArrowBackIcon />}
            label="zum Login"
            variant="contained"
            sx={{
              mt: 4,
              bgcolor: theme.palette.primary.main,
              "&:hover": { bgcolor: theme.palette.primary.dark },
            }}
          />
        </Paper>
      </Box>
    </TemplatePage>
  );
}
